import React from 'react';
import { RhfInputText, RhfInputTextBig, RhfInputTextBottom, RhfInputTextFloat } from "../../text";
import { InputTypeEnum } from "../manager-input.vm";
export const RhfInputTextManager = props => {
  const {
    inputManagerType
  } = props;
  if (inputManagerType === InputTypeEnum.NORMAL) {
    return /*#__PURE__*/React.createElement(RhfInputText, props);
  }
  if (inputManagerType === InputTypeEnum.BIG_INPUT) {
    return /*#__PURE__*/React.createElement(RhfInputTextBig, props);
  }
  if (inputManagerType === InputTypeEnum.FLOAT) {
    return /*#__PURE__*/React.createElement(RhfInputTextFloat, props);
  }
  if (inputManagerType === InputTypeEnum.BOTTOM) {
    return /*#__PURE__*/React.createElement(RhfInputTextBottom, props);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, "PON EL TYPE");
};